import Invitations from './container';

export default Invitations;



// WEBPACK FOOTER //
// ./src/routes/Invitations/index.js